import { render, staticRenderFns } from "./input-stuntextra.vue?vue&type=template&id=7d6ada6e&scoped=true&"
import script from "./input-stuntextra.vue?vue&type=script&lang=js&"
export * from "./input-stuntextra.vue?vue&type=script&lang=js&"
import style0 from "./input-stuntextra.vue?vue&type=style&index=0&id=7d6ada6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ada6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6ada6e')) {
      api.createRecord('7d6ada6e', component.options)
    } else {
      api.reload('7d6ada6e', component.options)
    }
    module.hot.accept("./input-stuntextra.vue?vue&type=template&id=7d6ada6e&scoped=true&", function () {
      api.rerender('7d6ada6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-stuntextra.vue"
export default component.exports